import Icon from "features/shared/components/icons/Icon";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

type Props = {
  titleCode: string;
  stepRoute?: string;
};

const ContractingSummaryHeader = ({ titleCode, stepRoute }: Props) => {
  // translations
  const tStepNames = useTranslation("contracting\\contractingStepNames").t;
  const tTerms = useTranslation("shared\\terms").t;

  // route
  const history = useHistory();

  // sub-renders
  const renderEditButton = () => {
    if (stepRoute) {
      return (
        <button
          className="btn btn-sm btn-outline-secondary ml-2"
          onClick={() => history.push(stepRoute)}
        >
          <Icon icon="edit" />
          <span className="ml-1">{tTerms("Update")}</span>
        </button>
      );
    }
  };

  // render
  return (
    <div className="d-flex justify-content-between align-items-center mb-3 mt-4">
      <h4 className="text-muted mb-0">{tStepNames(titleCode)}</h4>
      {renderEditButton()}
    </div>
  );
};

export default ContractingSummaryHeader;
